import { SeBarApiResponse } from '../lib/request'

export interface AuthenticatedGlobalSessionResponse {
  id: number | string
  trace_id?: string
  uuid?: string
  first_name?: string
  last_name?: string
  profile_image_url?: string
}

export interface AuthenticatedGlobalSessionState extends AuthenticatedGlobalSessionResponse {
  id: number | string
  trace_id?: string
  authenticated: true
  prev_trace_id?: string
}

export function mapAuthenticatedResponseToState(res: SeBarApiResponse<AuthenticatedGlobalSessionResponse>): AuthenticatedGlobalSessionState {
  return Object.assign(res, {
    authenticated: true,
    trace_id: res._trace_id,
  } as AuthenticatedGlobalSessionState)
}
